export default function ({state, commit}) {
    commit('data', JSON.parse(state.old));
    commit('set', {
        rebind: false,
        visible: false,
    });
    setTimeout(() => {
        commit('set', {
            rebind: true,
        });
    });
}